import { Navbar } from './Navbar';
import { DreShell } from '@/components/DreShell';
import { SponsorBanner } from '@/components/SponsorBanner';

export const Layout = ({ children }: { children: React.ReactNode }) => {
  return (
    <DreShell>
      <div className="min-h-screen">
        <Navbar />
        <SponsorBanner />
        <div className="relative pb-[calc(6rem+env(safe-area-inset-bottom))] md:pb-0">
          {children}
        </div>
      </div>
    </DreShell>
  );
};
